import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGraficoConsumoCorralTab = () => import('./TabView')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grafico_consumo_corral_viewer',
        name: 'Gráfico Consumo Corral Viewer',
        component: ViewGraficoConsumoCorralTab,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
